module.exports = __webpack_public_path__ + "static/gmail-icon-8ac3b5d4477a35d7c4e9f75fc077358d.png";